import { periodOptions } from 'pages/CalculatorPage/helpers';
import { config } from 'utils/config';

export const payeEmployedQuestions = {
  basicAnnualSalary: {
    getFieldName: (applicantNumber: any, incomeType: any) =>
      `applicants[${applicantNumber}].${incomeType}.basicAnnualSalary`,
    titleKey: 'affordabilityCalculator.payeEmployed.basicAnnualSalary.title',
    textKey: 'affordabilityCalculator.payeEmployed.basicAnnualSalary.text',
    textHref: config.env.VITE_INTERMEDIARIES_URL,
  },
  bonus: {
    getFieldName: (applicantNumber: any, incomeType: any) => `applicants[${applicantNumber}].${incomeType}.bonus`,
    titleKey: 'affordabilityCalculator.payeEmployed.bonus.title',
    textKey: 'affordabilityCalculator.payeEmployed.bonus.text',
    textHref: config.env.VITE_INTERMEDIARIES_URL,
    periodOptions,
  },
  commission: {
    getFieldName: (applicantNumber: any, incomeType: any) => `applicants[${applicantNumber}].${incomeType}.commission`,
    titleKey: 'affordabilityCalculator.payeEmployed.commission.title',
    textKey: 'affordabilityCalculator.payeEmployed.commission.text',
    textHref: config.env.VITE_INTERMEDIARIES_URL,
    periodOptions,
  },
  overtime: {
    getFieldName: (applicantNumber: any, incomeType: any) => `applicants[${applicantNumber}].${incomeType}.overtime`,
    titleKey: 'affordabilityCalculator.payeEmployed.overtime.title',
    textKey: 'affordabilityCalculator.payeEmployed.overtime.text',
    textHref: config.env.VITE_INTERMEDIARIES_URL,
    periodOptions,
  },
  guaranteedEmployeeBenefits: {
    getFieldName: (applicantNumber: any, incomeType: any) =>
      `applicants[${applicantNumber}].${incomeType}.guaranteedEmployeeBenefits`,
    titleKey: 'affordabilityCalculator.payeEmployed.guaranteedEmployeeBenefits.title',
    textKey: 'affordabilityCalculator.payeEmployed.guaranteedEmployeeBenefits.text',
    textHref: config.env.VITE_INTERMEDIARIES_URL,
    periodOptions,
  },
  error: {
    required: 'common.error.requiredField',
  },
};
